import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/wechat/deviceInfo',
            name: 'deviceInfo',
            component: () => import ('@/views/wechat/deviceInfo.vue'),
        },
        {
            path: "/",
            redirect: '/wechat/deviceInfo'
        }
    ]
});


// 微信浏览器专用标题设置方法
function setWechatTitle(title) {
    if (window.navigator.userAgent.includes('MicroMessenger')) {
        document.title = title;
        // 创建一个临时iframe来触发微信浏览器更新标题
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = './favicon.ico'; // 使用一个小图标
        iframe.onload = function() {
            setTimeout(() => {
                document.body.removeChild(iframe);
            }, 0);
        };
        document.body.appendChild(iframe);
    } else {
        document.title = title;
    }
}
const defaultTitle = '用户服务'; 
// 未登录路由拦截
router.beforeEach((to, from, next) => {
    const title = to.meta.title || defaultTitle;
    setWechatTitle(title);
    next()
});

// 当在渲染一个路由的过程中，需要尝试解析一个异步组件时发生错误
// router.onError((error) => {
//     console.log('error:'+ error.message); 
//     const pattern = /Loading chunk (\d)+ failed/g;
//     const isChunkLoadFailed = error.message.match(pattern);
//     if (isChunkLoadFailed) {
//       window.location.reload();
//     }else{
//       console.log(error)
//     }
// });
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }




export default router



// WEBPACK FOOTER //
// ./src/router/index.js